// ============================================================
// Industry Preset Definitions – NextInvoice
// ============================================================

import { calcUsedPoints } from "./modules";
import { plans, type PlanDefinition } from "./plans";

export interface PresetDefinition {
  id: string;
  label: string;
  /** Ordered list of recommended module IDs */
  moduleIds: string[];
}

/** Find the smallest plan that fits the preset's total points */
export function getPresetPlan(preset: PresetDefinition): PlanDefinition {
  const pts = calcUsedPoints(preset.moduleIds);
  return plans.find((p) => p.pointsIncluded === null || (p.pointsIncluded !== null && pts <= p.pointsIncluded)) ?? plans[plans.length - 1];
}

export const presets: PresetDefinition[] = [
  {
    id: "gesundheit_therapie",
    label: "Gesundheit & Therapie",
    moduleIds: [
      "kundenkartei",        // 1
      "rechnungen_mahnungen", // 2
      "buchhaltung_datev",    // 2
    ], // = 5 Punkte → Starter
  },
  {
    id: "agentur_beratung",
    label: "Agentur & Beratung",
    moduleIds: [
      "angebote",             // 1
      "auftragsbestaetigung", // 1
      "rechnungen_mahnungen", // 2
      "kundenkartei",         // 1
      "crm",                  // 3
      "buchhaltung_datev",    // 2
    ], // = 10 Punkte → Professional
  },
  {
    id: "it_dev",
    label: "IT & Entwicklung",
    moduleIds: [
      "angebote",             // 1
      "auftragsbestaetigung", // 1
      "rechnungen_mahnungen", // 2
      "kundenkartei",         // 1
      "ticketsystem",         // 2
      "projektmanagement",    // 2
      "buchhaltung_datev",    // 2
    ], // = 11 Punkte → Professional
  },
  {
    id: "handwerk",
    label: "Handwerk & Gewerbe",
    moduleIds: [
      "angebote",             // 1
      "auftragsbestaetigung", // 1
      "rechnungen_mahnungen", // 2
      "kundenkartei",         // 1
      "artikelstamm",         // 2
      "lager",                // 3
      "buchhaltung_datev",    // 2
    ], // = 12 Punkte → Professional
  },
  {
    id: "handel_ecom",
    label: "Handel & E-Commerce",
    moduleIds: [
      "rechnungen_mahnungen", // 2
      "kundenkartei",         // 1
      "artikelstamm",         // 2
      "lager",                // 3
      "einkauf",              // 3
      "shopanbindung",        // 3
      "buchhaltung_datev",    // 2
    ], // = 16 Punkte → Business
  },
  {
    id: "logistik",
    label: "Spedition & Logistik",
    moduleIds: [
      "rechnungen_mahnungen", // 2
      "auftragsbestaetigung", // 1
      "kundenkartei",         // 1
      "lager",                // 3
      "einkauf",              // 3
      "personal",             // 3
      "fuhrpark",             // 2
      "buchhaltung_datev",    // 2
    ], // = 17 Punkte → Business
  },
];

/** Look up a preset by ID (returns undefined if not found) */
export function getPresetById(id: string): PresetDefinition | undefined {
  return presets.find((p) => p.id === id);
}
